module.exports = __webpack_public_path__ + "static/media/on5.2bab0104.png";